package com.essntl.features.message.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.message.ui.all_conversation.AllConversationEvent
import com.essntl.features.message.ui.all_conversation.AllConversationState
import com.essntl.features.message.ui.all_conversation.components.ConversationList
import com.essntl.features.message.ui.chat.ChatEvent
import com.essntl.features.message.ui.chat.ChatState
import com.essntl.features.message.ui.chat.components.ChatHeader
import com.essntl.features.message.ui.chat.components.ChatUi
import com.essntl.features.message.ui.chat.rememberGroupParticipants
import com.essntl.features.message.ui.chat.rememberMessagesUiState
import com.essntl.features.message.ui.components.MessageHeader
import com.essntl.uikit.components.chat.conversation.overviewcard.ConversationOverviewUiState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun MessageScreen(
    filteredConversations: List<WhapiChatModel>,
    conversationState: AllConversationState,
    onConversationEvent: (AllConversationEvent) -> Unit,
    chatState: ChatState,
    onChatEvent: (ChatEvent) -> Unit,
    onNavigation: (MessageNavigation) -> Unit,
    selectedConversation: WhapiChatModel?,
    client: ClientModel,
    selectedConversationUiState: ConversationOverviewUiState?,
) {
    val messagesUiState = chatState.rememberMessagesUiState()

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(MaterialTheme.esColorScheme.bgPrimary),
    ) {
        MessageHeader(isLoading = conversationState.isLoading)
        Spacer(modifier = Modifier.height(1.spacing))
        Row {
            ConversationList(
                state = conversationState,
                onEvent = onConversationEvent,
                filteredConversations = filteredConversations,
                selectedConversationId = selectedConversation?.id,
                onFilterOptionsChange = {
                    onConversationEvent(AllConversationEvent.ChangeFilterOptions(it))
                },
                onConversationClicked = { conversationId, conversationType ->
                    if (conversationId == selectedConversation?.id) return@ConversationList

                    if (conversationType == ConversationOverviewUiState.ChatType.Contact)
                        onChatEvent(ChatEvent.GetWhapiChatById(conversationId))
                    else if (conversationType == ConversationOverviewUiState.ChatType.Group)
                        onChatEvent(ChatEvent.GetWhapiGroupById(conversationId))

                    onChatEvent(ChatEvent.GetAllWhapiMessagesByChatId(conversationId))
                    onConversationEvent(AllConversationEvent.SelectConversation(conversationId))
                    onNavigation(MessageNavigation.CloseSidePanel)
                },
                loadNextPage = {
                    onConversationEvent(AllConversationEvent.GetNextConversationsPage)
                },
                modifier = Modifier
                    .fillMaxHeight()
                    .fillMaxWidth(.23F),
            )

            if (selectedConversationUiState != null)
                ChatUi(
                    messages = messagesUiState,
                    onSend = {
                        val phoneNumber = selectedConversation?.phoneNumber
                        if (phoneNumber != null)
                            onChatEvent(
                                ChatEvent.SendWhatsAppMessage(
                                    chatId = selectedConversation.id,
                                    text = it,
                                    phoneNumber = phoneNumber,
                                    onSuccess = { message ->
                                        onConversationEvent(
                                            AllConversationEvent.UpdateChatLastMessage(
                                                chatId = selectedConversation.id,
                                                lastMessage = message,
                                            ),
                                        )
                                    },
                                ),
                            )
                    },
                    onReact = { messageId, emoji ->
                        val phoneNumber = selectedConversation?.phoneNumber
                        if (phoneNumber != null)
                            onChatEvent(
                                ChatEvent.ReactToMessage(
                                    whapiMessageId = messageId,
                                    emoji = emoji,
                                    onSuccess = { message ->
                                        onConversationEvent(
                                            AllConversationEvent.UpdateChatLastMessage(
                                                chatId = selectedConversation.id,
                                                lastMessage = message,
                                            ),
                                        )
                                    },
                                ),
                            )
                    },
                    messagesHeader = {
                        ChatHeader(
                            conversationUiState = selectedConversationUiState,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(horizontal = 10.dp)
                                .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                                .background(MaterialTheme.esColorScheme.bgSecondary)
                                .clickable {
                                    client.telephone?.let {
                                        onNavigation(
                                            MessageNavigation.ClientProfile(
                                                it,
                                                selectedConversationUiState.contact,
                                            ),
                                        )
                                    }
                                }
                                .padding(
                                    vertical = 24.dp,
                                    horizontal = 26.dp,
                                ),
                        )
                    },
                )
        }
    }
}